import Vue from 'vue';
import i18next from 'i18next';
import VueI18Next from '@panter/vue-i18next';
import Backend from 'i18next-http-backend';
import * as appStorageUtil from '@/utils/localstorage-util';

Vue.use(VueI18Next);

function normalizeLanguage(rawLanguage: string | null) {
    if (!rawLanguage) {
        return '';
    }

    return rawLanguage.replace(/"/g, '').toLowerCase();
}

function getInitialLanguage() {
    const hasAuth = !!appStorageUtil.getAuthorizationToken();
    if (!hasAuth) {
        return 'en';
    }

    const storedLanguage = normalizeLanguage(appStorageUtil.getItem(appStorageUtil.CURRENT_USER_LANG));
    if (storedLanguage === 'en' || storedLanguage === 'jp' || storedLanguage === 'ja') {
        return storedLanguage === 'ja' ? 'jp' : storedLanguage;
    }

    const envLanguage = normalizeLanguage(process.env.VUE_APP_I18N_LOCALE || '');
    if (envLanguage === 'en' || envLanguage === 'jp' || envLanguage === 'ja') {
        return envLanguage === 'ja' ? 'jp' : envLanguage;
    }

    return 'en';
}

i18next
    .use(Backend)
    .init({
        lng: getInitialLanguage(),
        fallbackLng: process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'en',
        backend: {
            loadPath: `${process.env.VUE_APP_BASE_API_URL}/affiliates/localization?lang={{lng}}&ns={{ns}}`,
        },
        preload: ['en', 'jp', 'br'],
        returnNull: false,
    });

export default new VueI18Next(i18next);
